import { createApiRef } from '@backstage/core-plugin-api';
import { ApiBlueprint } from '@backstage/frontend-plugin-api';
import { configApiRef, fetchApiRef } from '@backstage/core-plugin-api';
import { MaxxApiClient } from './MaxxApiClient';
import { keycloakAuthApiRef } from 'app/src/modules/auth';

// https://localhost:3000/maxx/api/users/1177/interim-summary/2021-07-31
export type MaxxInterimSummary = {
  annualLeave: number;
  flextimeLowerLimit: number;
  flextimeUpperLimit: number;
  hoursBookedOnDay: number;
  targetWorkingDaysInMonth: number;
  targetWorkingHours: number;
  balances: {
    FLEXTIME: number,
    ILLNESS: number,
    LEAVE: number,
    PARENTAL_LEAVE?: number,
  }
  userId: string,
  accessDateString: string,
}

export type MaxxWeekSummary = {
  bookings: {
    hoursBookedOnDay: number;
    FLEXTIME: number;
    hoursPercentage: number;
  }[];
  userId: string;
  accessDateString: string;
  accessFLEXTIME: number;
};

export interface MaxxApi {
  readInterimSummary(): Promise<MaxxInterimSummary>;
  readWeekSummary(accessDateString: string): Promise<MaxxWeekSummary>;
}

export const maxxApiRef = createApiRef<MaxxApi>({
  id: 'plugin.home-maxx.api',
});

export const maxxApi = ApiBlueprint.make({
  name: 'maxx-api',
  params: defineParams =>
    defineParams({
      api: maxxApiRef,
      deps: {
        configApi: configApiRef,
        fetchApi: fetchApiRef,
        oauthApi: keycloakAuthApiRef,
      },
      factory: ({ configApi, fetchApi, oauthApi }) =>
        new MaxxApiClient({ configApi, fetchApi, oauthApi }),
    }),
});